import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, Trash2 } from "lucide-react";
import api, { formatErr } from "../../lib/api";

export default function AdmDiscounts() {
  const [list, setList] = useState([]);
  const [creating, setCreating] = useState(false);
  const [form, setForm] = useState({ code: "", percent: 10, active: true });
  const refresh = () => api.get("/admin/discounts").then(r=>setList(r.data));
  useEffect(()=>{ refresh(); }, []);
  const create = async (e) => {
    e.preventDefault();
    try { await api.post("/admin/discounts", { ...form, percent: parseFloat(form.percent) }); toast.success("Created"); setCreating(false); setForm({code:"",percent:10,active:true}); refresh(); }
    catch (e) { toast.error(formatErr(e)); }
  };
  const toggle = async (d) => { await api.put(`/admin/discounts/${d.id}`, { active: !d.active }); refresh(); };
  const del = async (d) => { if (!window.confirm("Delete?")) return; await api.delete(`/admin/discounts/${d.id}`); refresh(); };
  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div><div className="overline mb-2">Marketing</div><h1 className="font-display text-4xl text-white">Discount Codes</h1></div>
        <button onClick={()=>setCreating(!creating)} className="btn-primary"><Plus size={13}/> New Code</button>
      </div>
      {creating && (
        <form onSubmit={create} className="card-luxe p-5 grid md:grid-cols-3 gap-3">
          <input required placeholder="CODE" className="input-box uppercase" value={form.code} onChange={(e)=>setForm({...form, code:e.target.value.toUpperCase()})}/>
          <input required type="number" placeholder="Percent" className="input-box" value={form.percent} onChange={(e)=>setForm({...form, percent:e.target.value})}/>
          <button className="btn-primary">Create</button>
        </form>
      )}
      <div className="card-luxe overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="text-[11px] uppercase tracking-luxe text-white/40"><tr className="border-b border-white/5"><th className="text-left p-4">Code</th><th>Percent</th><th>Status</th><th></th></tr></thead>
          <tbody>
            {list.map(d => (
              <tr key={d.id} className="border-b border-white/5">
                <td className="p-4 font-display text-lg text-copper">{d.code}</td>
                <td>{d.percent}%</td>
                <td><button onClick={()=>toggle(d)} className={`text-xs uppercase tracking-luxe px-2 py-1 ${d.active?"bg-[#32D74B]/10 text-[#32D74B]":"bg-white/5 text-white/40"}`}>{d.active?"● Active":"○ Inactive"}</button></td>
                <td className="p-4 text-right"><button onClick={()=>del(d)} className="btn-ghost text-red-400"><Trash2 size={13}/></button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
